var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCtMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 12,
    fill: "#101013"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5544 29.6655C35.5544 30.4011 34.9577 30.9978 34.2221 30.9978C33.4864 30.9978 32.8897 30.4011 32.8897 29.6655C32.8897 28.9298 33.4864 28.3331 34.2221 28.3331C34.9555 28.3331 35.5544 28.9298 35.5544 29.6655Z",
    fill: "#03CDEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8882 14.7772C12.9606 14.7772 9.77722 17.9606 9.77722 21.8882C9.77722 25.8159 12.9606 28.9993 16.8882 28.9993H19.7765C20.2669 28.9993 20.6662 29.3964 20.6662 29.889C20.6662 30.3794 20.2691 30.7787 19.7765 30.7787H16.8882C11.9797 30.7765 8 26.7967 8 21.8882C8 16.9797 11.9797 13 16.8882 13H34.6647C35.1552 13 35.5544 13.3971 35.5544 13.8897C35.5544 14.3801 35.1573 14.7794 34.6647 14.7794H16.8882V14.7772Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3338 21.8882C13.3338 19.9244 14.9266 18.3338 16.8882 18.3338H23.9993V30.1103C23.9993 30.6007 24.3964 31 24.889 31C25.3794 31 25.7787 30.6029 25.7787 30.1103V17.4441C25.7787 16.9537 25.3815 16.5544 24.889 16.5544H16.8882C13.9436 16.5544 11.5544 18.9414 11.5544 21.8882C11.5544 24.8351 13.9414 27.2221 16.8882 27.2221H19.7765C20.2669 27.2221 20.6662 26.825 20.6662 26.3324C20.6662 25.8398 20.2691 25.4427 19.7765 25.4427H16.8882C14.9244 25.4427 13.3338 23.8521 13.3338 21.8882Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4434 16.5544C28.9338 16.5544 29.3331 16.9515 29.3331 17.4441V30.1103C29.3331 30.6007 28.936 31 28.4434 31C27.953 31 27.5537 30.6029 27.5537 30.1103V17.4441C27.5537 16.9537 27.953 16.5544 28.4434 16.5544Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtMobileIcon);
export default __webpack_public_path__ + "static/media/CTMobileIcon.0150721aa6cb98fca48cccab11192840.svg";
export { ForwardRef as ReactComponent };